module.exports = __webpack_public_path__ + "static/media/handouts.72d42543.md";